(() => {
  if (!document.body.classList.contains('template-collection') && !document.body.classList.contains('template-search')) return;

  const state = {
    mobileOpen: new Set(),
    desktopOpen: new Set(),
    mobileScroll: 0,
    desktopScroll: 0,
  };

  const capture = () => {
    document.querySelectorAll('#FacetsWrapperDesktop details[open]').forEach((d) => d.id && state.desktopOpen.add(d.id));
    document.querySelectorAll('#FacetsWrapperDesktop details:not([open])').forEach((d) => d.id && state.desktopOpen.delete(d.id));
    document.querySelectorAll('#FacetsWrapperMobile details[open]').forEach((d) => d.id && state.mobileOpen.add(d.id));
    document.querySelectorAll('#FacetsWrapperMobile details:not([open])').forEach((d) => d.id && state.mobileOpen.delete(d.id));
    state.desktopScroll = document.querySelector('[data-ttcat-facet-scroll]')?.scrollTop || 0;
    state.mobileScroll = document.querySelector('[data-ttcat-mobile-scroll]')?.scrollTop || 0;
  };

  const restore = () => {
    state.desktopOpen.forEach((id) => { const d = document.getElementById(id); if (d) d.open = true; });
    state.mobileOpen.forEach((id) => { const d = document.getElementById(id); if (d) d.open = true; });
    const ds = document.querySelector('[data-ttcat-facet-scroll]');
    const ms = document.querySelector('[data-ttcat-mobile-scroll]');
    if (ds) ds.scrollTop = state.desktopScroll;
    if (ms) ms.scrollTop = state.mobileScroll;
  };

  document.addEventListener('toggle', (event) => {
    if (event.target?.matches?.('.ttcat-facet, .ttcat-mobile-facet')) capture();
  }, true);

  document.addEventListener('tt:facets:before-render', capture);
  document.addEventListener('tt:facets:rendered', () => requestAnimationFrame(restore));

  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-ttcat-close]');
    if (!close) return;
    const details = close.closest('.ttcat-mobile-filter__details');
    if (details?.open) {
      const summary = details.querySelector(':scope > summary');
      if (summary) summary.click();
      else details.removeAttribute('open');
    }
  });

  // Avoid body scroll behind the mobile filter drawer even if the theme's
  // menu-drawer helper misses this custom presentation.
  const syncBodyLock = () => {
    const open = !!document.querySelector('.ttcat-mobile-filter__details[open]');
    document.documentElement.classList.toggle('ttcat-filter-open', open);
  };
  document.addEventListener('toggle', (event) => {
    if (event.target?.matches?.('.ttcat-mobile-filter__details')) syncBodyLock();
  }, true);



  // This drawer is intentionally independent from Dawn's menu-drawer custom element.
  // Close it cleanly with Escape and keep focus on the Filter trigger.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const details = document.querySelector('.ttcat-mobile-filter__details[open]');
    if (!details) return;
    event.preventDefault();
    const summary = details.querySelector(':scope > summary');
    details.removeAttribute('open');
    syncBodyLock();
    summary?.focus({ preventScroll: true });
  });

  // Clicking the backdrop closes the drawer.
  document.addEventListener('click', (event) => {
    const form = event.target.closest('.ttcat-mobile-drawer');
    if (!form || event.target.closest('.ttcat-mobile-drawer__panel')) return;
    const details = form.closest('.ttcat-mobile-filter__details');
    details?.querySelector(':scope > summary')?.click();
  });
})();

/* V3.8.2 — size the desktop filter island to the part of the viewport that is
   actually visible at its current sticky position. A pure 100vh calculation
   was too tall while the catalogue hero was still above the sidebar, which is
   why lower facets could be clipped without ever becoming scrollable. */
(() => {
  if (!document.body.classList.contains('template-collection') && !document.body.classList.contains('template-search')) return;

  let frame = 0;
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const panel = document.querySelector('.ttcat-facets__inner');
      const sidebar = panel?.closest('.filters-bleed');
      if (!panel || !sidebar) return;

      if (window.innerWidth < 990) {
        panel.style.removeProperty('--ttcat-facet-height');
        return;
      }

      const viewportHeight = window.visualViewport?.height || document.documentElement.clientHeight || window.innerHeight;
      const top = Math.max(0, sidebar.getBoundingClientRect().top);
      const bottomGap = 16;
      const available = Math.max(320, Math.floor(viewportHeight - top - bottomGap));
      panel.style.setProperty('--ttcat-facet-height', `${available}px`);
    });
  };

  schedule();
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('tt:facets:rendered', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();
